import { IOptionItem } from '@wyz/types';
import { useMemo } from 'react';
import { SelectField } from '~/common/components';
import { Trans } from '~/common/context';
import { PurchaseTracking } from '~/purchase/helpers';
import { IWcwOffer } from '~/purchase/types';

type Props = {
  products: Array<IWcwOffer>;
};

const toStringOptions = (values: string[]): IOptionItem<string>[] =>
  [...new Set(values)].filter(Boolean).map((v) => ({ label: v, value: v }));

const toNumberOptions = (values: number[]): IOptionItem<number>[] =>
  [...new Set(values)]
    .filter((v) => v != null)
    .map((v) => ({ label: String(v), value: v }));

function WcwFilterBar({ products }: Props) {
  const wheelNameOptions = useMemo(
    () => toStringOptions(products.map((p) => p.wheel.name)),
    [products],
  );
  const rimDiameterOptions = useMemo(
    () => toNumberOptions(products.map((p) => p.wheel.rimDiameter)),
    [products],
  );
  const rimTypeOptions = useMemo(
    () => toStringOptions(products.map((p) => p.wheel.rimType)),
    [products],
  );
  const brandOptions = useMemo(
    () => toStringOptions(products.map((p) => p.tyre.brand.name)),
    [products],
  );
  const versionOptions = useMemo(
    () =>
      toStringOptions(
        products.flatMap((p) => p.compatibleVehicles.map((v) => v.version)),
      ),
    [products],
  );

  return (
    <>
      <SelectField<true>
        isMulti
        name='wheelNames'
        placeholder={
          <Trans i18nKey='app.purchase.wcw.result_page.filter.wheel_name' />
        }
        options={wheelNameOptions}
        onSelect={() => PurchaseTracking.trackWcwFilterToggled('wheelNames')}
        isClearable
        size='sm'
        formGroupClassName=''
      />

      <SelectField<true, IOptionItem<number>>
        isMulti
        name='rimDiameters'
        placeholder={
          <Trans i18nKey='app.purchase.wcw.result_page.filter.rim_diameter' />
        }
        options={rimDiameterOptions}
        onSelect={() => PurchaseTracking.trackWcwFilterToggled('rimDiameters')}
        isClearable
        size='sm'
        formGroupClassName=''
      />

      <SelectField<true>
        isMulti
        name='rimTypes'
        placeholder={
          <Trans i18nKey='app.purchase.wcw.result_page.filter.rim_type' />
        }
        options={rimTypeOptions}
        onSelect={() => PurchaseTracking.trackWcwFilterToggled('rimTypes')}
        isClearable
        size='sm'
        formGroupClassName=''
      />

      <SelectField<true>
        isMulti
        name='brands'
        placeholder={<Trans i18nKey='app.common.product.brands' />}
        options={brandOptions}
        onSelect={() => PurchaseTracking.trackWcwFilterToggled('brands')}
        isClearable
        size='sm'
        formGroupClassName=''
      />

      <SelectField<true>
        isMulti
        name='versions'
        placeholder={<Trans i18nKey='app.purchase.wcw.search_page.versions' />}
        options={versionOptions}
        onSelect={() => PurchaseTracking.trackWcwFilterToggled('versions')}
        isClearable
        size='sm'
        formGroupClassName=''
      />
    </>
  );
}

export default WcwFilterBar;
